import DataCollectionSDK from "../../../../src/mdx/sdk/data-collection.mdx";
import * as React from 'react';
export default {
  DataCollectionSDK,
  React
};